import cx from 'classnames'
import { Field } from '@/console/ui/Field'
import { OriginRemapField, OriginRemapFieldErrors, OriginRemapFormValues } from './originRemap'
import styles from './OriginRemap.module.css'

type FieldDefinition = { field: OriginRemapField; label: string; placeholder: string; helper?: string; numeric?: boolean; wide?: boolean }

const FIELD_DEFINITIONS: FieldDefinition[] = [
  {
    field: 'misMappedInboundReportId',
    label: 'A — misMappedInboundReportId (오매핑된 반품 입고실적)',
    placeholder: '24191821',
    helper: '가이드 §2.2 ② 조회 결과의 id 예요. 여러 건이면 센터 확인으로 골라요.',
    numeric: true,
  },
  {
    field: 'blockedInboundReportId',
    label: 'B — blockedInboundReportId (과입고 가드에 막힌 반품 입고실적)',
    placeholder: '24233781',
    helper: 'Grafana 알림의 inboundReportId 가 B 예요. A 와 바꿔 넣어도 검증을 통과할 수 있으니 주의하세요.',
    numeric: true,
  },
  {
    field: 'correctRefNo1',
    label: 'Y — correctRefNo1 (A 의 실제 원주문 번호)',
    placeholder: '202608281943280002',
    helper: '가이드 §2.2 ④ 조회 결과의 REF_NO1 이에요.',
  },
  {
    field: 'correctRefNo2',
    label: 'Y — correctRefNo2 (A 의 실제 원주문 일련번호)',
    placeholder: '449594338',
    helper: '④ 와 같은 행의 REF_NO2 예요. ③ 결과와 섞어 쓰지 마세요.',
  },
  {
    field: 'reason',
    label: '사유 (서버 로그에 원문 그대로 남아요)',
    placeholder: 'LOGISPRD-XXXXX 센터 확인 완료 — 반송장 8447****6063 은 202608281943280002 의 반품',
    helper: '한 줄 · 500자 이하. 티켓 키와 센터 확인 근거를 적고, 고객 이름·주소·연락처는 적지 마세요. 송장번호는 가운데를 가려요(8447****6063).',
    wide: true,
  },
]

export type OriginRemapFormFieldsProps = {
  values: OriginRemapFormValues
  errors: OriginRemapFieldErrors
  disabled: boolean
  onChange: (field: OriginRemapField, value: string) => void
}

/** 빈 칸에는 에러를 띄우지 않는다 — 아직 입력하지 않은 필드까지 붉게 칠하지 않기 위해서다. */
export const OriginRemapFormFields = ({ values, errors, disabled, onChange }: OriginRemapFormFieldsProps): JSX.Element => (
  <div className={styles.form}>
    {FIELD_DEFINITIONS.map(({ field, label, placeholder, helper, numeric, wide }) => {
      const visibleError = values[field].length > 0 ? errors[field] : undefined
      return (
        <div key={field} className={cx(styles.group, wide && styles.wide)}>
          <Field label={label}>
            <input
              type="text"
              inputMode={numeric ? 'numeric' : undefined}
              spellCheck={false}
              autoComplete="off"
              placeholder={placeholder}
              value={values[field]}
              disabled={disabled}
              onChange={(event) => onChange(field, event.target.value)}
            />
          </Field>
          {helper ? <p className={styles.helper}>{helper}</p> : null}
          {visibleError ? <p className={styles.fieldError}>{visibleError}</p> : null}
        </div>
      )
    })}
  </div>
)
